import { Style, Fill, Stroke, Circle as CircleStyle, Text } from 'ol/style';

export const MARKUP_COLORS = [
  '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
  '#8B5CF6', '#EC4899', '#06B6D4', '#F97316',
];

export function getMarkupColor(index: number): string {
  return MARKUP_COLORS[index % MARKUP_COLORS.length];
}

export function createMarkupStyle(color: string, selected: boolean): Style {
  return new Style({
    fill: new Fill({ color: color + '33' }),
    stroke: new Stroke({
      color,
      width: selected ? 3 : 2,
      lineDash: selected ? undefined : [6, 4],
    }),
  });
}

export function createMeasurementStyle(color: string): Style {
  return new Style({
    stroke: new Stroke({ color, width: 2 }),
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color }),
      stroke: new Stroke({ color: '#fff', width: 2 }),
    }),
  });
}

export function createDrawingStyle(): Style {
  return new Style({
    fill: new Fill({ color: 'rgba(59, 130, 246, 0.1)' }),
    stroke: new Stroke({
      color: '#3B82F6',
      width: 2,
      lineDash: [8, 4],
    }),
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: '#3B82F6' }),
      stroke: new Stroke({ color: '#fff', width: 2 }),
    }),
  });
}

export function createSlotPolylineStyle(color: string, measureLabel: string | null): Style[] {
  const styles: Style[] = [
    new Style({
      stroke: new Stroke({
        color,
        width: 4,
      }),
    }),
  ];
  if (measureLabel) {
    styles.push(
      new Style({
        text: new Text({
          text: measureLabel,
          font: 'bold 13px sans-serif',
          fill: new Fill({ color }),
          stroke: new Stroke({ color: '#000', width: 3 }),
          placement: 'line',
          overflow: true,
          offsetY: -10,
        }),
      }),
    );
  }
  return styles;
}

export function createCountStyle(count: number, color: string): Style {
  return new Style({
    image: new CircleStyle({
      radius: 14,
      fill: new Fill({ color }),
      stroke: new Stroke({ color: '#fff', width: 2 }),
    }),
    text: new Text({
      text: String(count),
      fill: new Fill({ color: '#fff' }),
      font: 'bold 12px sans-serif',
    }),
  });
}
